import {
  Component,
  ElementRef,
  inject,
  viewChild,
  ViewChild,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalsComponent } from 'src/app/common/modals/modals.component';
import { ModalsService } from 'src/app/services/Modals/modals.service';
import { ToastComponent } from 'src/app/common/toast/toast.component';
import { ToastService } from 'src/app/services/Toast/toast.service';
import { HeaderComponent } from 'src/app/common/templates/header/header.component';
import { FooterComponent } from 'src/app/common/templates/footer/footer.component';
import {
  SidebarComponent,
  SidebarLink,
} from 'src/app/common/internal-sidebar/internal-sidebar.component';
import { PreviewImageComponent } from 'src/app/common/preview-image/preview-image.component';
import { PreviewImageService } from 'src/app/services/Image-preview/preview-image-service.service';

@Component({
  selector: 'product-admin-template',
  imports: [
    SidebarComponent,
    RouterOutlet,
    FooterComponent,
    ModalsComponent,
    ToastComponent,
    HeaderComponent,
    PreviewImageComponent,
  ],
  templateUrl: './template.component.html',
  styleUrl: './template.component.scss',
})
export class TemplateComponent {
  // refs
  @ViewChild('modals', { static: true }) modalsComponent!: ModalsComponent;
  @ViewChild('toast', { static: true }) toastComponent!: ToastComponent;
  @ViewChild('sidebar', { static: true, read: ElementRef })
  sidebar!: ElementRef;
  preview = viewChild.required<PreviewImageComponent>('preview');

  // services
  private modals = inject(ModalsService);
  private toasts = inject(ToastService);
  private previewService = inject(PreviewImageService);

  // data
  navLinks!: SidebarLink[];

  constructor() {}
  ngOnInit() {
    this.modals.bindComponent(this.modalsComponent);
    this.toasts.bindComponent(this.toastComponent);
    this.previewService.bindComponent(this.preview());
    this.initSidebar();
  }

  initSidebar() {
    this.navLinks = [
      {
        name: 'Dashboard',
        icon: 'bi-house',
        url: '/product-admin',
      },
      {
        name: 'Quotation',
        icon: 'bi-tags',
        url: '/product-admin/quotation',
      },
      {
        name: 'Clients',
        icon: 'bi-people',
        url: '/product-admin/clients',
      },
      {
        name: 'Products',
        icon: 'bi-box',
        url: '/product-admin/products',
      },
      {
        name: 'Product Concerns',
        icon: 'bi-exclamation-square',
        url: '/product-admin/concerns',
      },
      {
        name: 'Pricing Section',
        icon: 'bi-cash',
        url: '/product-admin/pricing',
      },
      {
        name: 'Academe',
        icon: 'bi-mortarboard',
        url: '',
        children: [
          {
            name: 'Academe Tags',
            icon: 'bi-mortarboard',
            url: '/product-admin/academe/tags',
          },
          {
            name: 'Academe Brands',
            icon: 'bi-mortarboard',
            url: '/product-admin/academe/brands',
          },
        ],
      },
      {
        name: 'Industrial',
        icon: 'bi-wrench-adjustable-circle',
        url: '',
        children: [
          {
            name: 'Industrial Tags',
            icon: 'bi-wrench-adjustable-circle',
            url: '/product-admin/industrial/tags',
          },
          {
            name: 'Industrial Brands',
            icon: 'bi-wrench-adjustable-circle',
            url: '/product-admin/industrial/brands',
          },
        ],
      },
      {
        name: 'Events',
        icon: 'bi-calendar-event',
        url: '/product-admin/events',
      },
      {
        name: 'FAQs',
        icon: 'bi-question-circle',
        url: '/product-admin/faq-manage',
      },
      {
        name: 'Activity Logs',
        icon: 'bi-clock',
        url: '/product-admin/activity-logs',
      },
    ];
  }
  showSidebar() {
    this.sidebar?.nativeElement.focus();
  }
}
